import { useState } from "react";
import { Button, Modal, Form, Upload, UploadFile, UploadProps, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const UploadInvoicePdfModal = (props: any) => {
  const { isModalOpen, assignment, onCancel, onUploadInvoicePdf } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const onFinish = (values: any) => {
    values["id"] = assignment?.id;
    onUploadInvoicePdf(values, setLoading, form, fileList);
    setFileList([]);
  };

  const onFinishFailed = (errorInfo: any) => {
    setFileList([]);
    console.log("Failed:", errorInfo);
  };

  const uProps: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file, fileList) => {
      const maxFileSize = 250 * 1024 * 1024; // 250MB limit

      if (file.size > maxFileSize) {
        message.error(`${file.name} file upload failed (exceeds 250MB)`);
        console.error("File size exceeds the limit of 250MB");
        return false;
      }

      setFileList(fileList);

      return false;
    },
    accept: "application/pdf",
    fileList
  };

  return (
    <Modal
      title={`Upload Invoice Pdf - ${assignment?.ecb_install_code || assignment?.ecb_survey_code}`}
      open={isModalOpen}
      onCancel={() => {
        setFileList([]);
        form.resetFields();
        onCancel();
      }}
      footer={false}
      destroyOnClose
    >
      <Form
        name="preview_email_form"
        form={form}
        initialValues={{}}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upload {...uProps}>
          <Button icon={<UploadOutlined />}>Select File</Button>
        </Upload>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                setFileList([]);
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {loading ? "Uploading ...." : "Upload"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadInvoicePdfModal;
